export default __webpack_public_path__ + "static/media/scdream1.8d091dcc.woff";